import React, { useEffect, useState } from 'react';
import { ContentBlock, Box, Stack } from 'braid-design-system';
import { ListBrandsQuery } from 'src/gql/server-side/queries-hg';
import { useLazyQuery } from '@apollo/client';

import IntroBanner from '../BrandList/IntroBanner/IntroBanner';
import BrandListingContainer from '../BrandList/Listing/BrandListingContainer';

import { trackListPageLoad } from 'src/modules/analyticsTracker';

import { useWithOwner } from '../helpers/use-with-owner';
import { clearEditorStates } from 'src/gql/client-side/actions';
import withEmailVerify from '../helpers/WithEmailVerify/withEmailVerify';
import { AsiaBrandAlertMessage } from '../common/AsiaBrandAlertMessage/AsiaBrandAlertMessage';
import { isAsiaCover } from '../BrandEditor/utils/is-asia-cover';

let getBrands: () => void;
export const getRefetchBrandListQuery = () => getBrands;

const ListBrands = () => {
  const owner = useWithOwner();

  useEffect(() => {
    trackListPageLoad();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => clearEditorStates(), []);

  const [brands, setBrands] = useState([]);
  const [getBrandsList, { error, loading, data }] = useLazyQuery(
    ListBrandsQuery,
    {
      variables: { owner },
      fetchPolicy: 'no-cache',
    },
  );
  const shouldDisplayAsiaCoverMessage =
    brands.findIndex((brand) => isAsiaCover(brand)) !== -1;

  getBrands = getBrandsList;

  useEffect(() => {
    getBrandsList();
  }, [getBrandsList]);

  useEffect(() => {
    const brandsResp = data?.brands;
    if (brandsResp) {
      setBrands(brandsResp);
    }
  }, [data]);

  return (
    <>
      <ContentBlock>
        {shouldDisplayAsiaCoverMessage && (
          <Box marginTop="medium">
            <AsiaBrandAlertMessage isOnListPage />
          </Box>
        )}

        <Box
          marginTop={shouldDisplayAsiaCoverMessage ? 'large' : 'xxlarge'}
          marginBottom="large"
        >
          <Stack space="xlarge">
            <IntroBanner />
            <BrandListingContainer
              brands={brands}
              loading={loading}
              error={error}
              owner={owner}
            />
          </Stack>
        </Box>
      </ContentBlock>
    </>
  );
};

export default withEmailVerify(ListBrands);
